// extracted by mini-css-extract-plugin
export default {"gpa__register":"RegisterButton_gpa__register__qzPCg","gpa__active_link":"RegisterButton_gpa__active_link__8Q7ob","gpa__dark_mode":"RegisterButton_gpa__dark_mode__AmVmO"};